type TimeslotOption = {
  label: string
  value: string
}

type TimeslotOptions = TimeslotOption[]

const ISSUE_TIMESLOT_START_AT = 8
const ISSUE_TIMESLOT_END_AT = 19
const ISSUE_TIMESLOT_STEP = 30

const getTimeslots = (): TimeslotOptions => {
  const timeslotOptions = []

  let hour = ISSUE_TIMESLOT_START_AT
  let minute = 0

  while (hour < ISSUE_TIMESLOT_END_AT) {
    const startTime = `${hour.toString().padStart(2, "0")}:${minute
      .toString()
      .padStart(2, "0")}`

    minute += ISSUE_TIMESLOT_STEP

    if (minute === 60) {
      minute = 0
      hour++
    }

    const endTime = `${hour.toString().padStart(2, "0")}:${minute
      .toString()
      .padStart(2, "0")}`

    const label = `${startTime} - ${endTime}`

    timeslotOptions.push({ label, value: startTime })
  }

  return timeslotOptions
}

export { getTimeslots }
